import { cn } from '~/utils/cn';

interface EmailLinkProps {
  email: string;
  className?: string;
  /** Optional display text; defaults to the email itself. */
  children?: React.ReactNode;
}

/**
 * Renders a `mailto:` anchor for an email address. Used anywhere the UI needs
 * to expose a clickable email (e.g. "contact support@lily.ai").
 */
export function EmailLink({ email, className, children }: EmailLinkProps) {
  return (
    <a href={`mailto:${email}`} className={cn('text-primary hover:underline', className)}>
      {children ?? email}
    </a>
  );
}
